import instance from '@/http';

export default {
	getAutoList(data) {
		return instance().post("/filterLoads", data).then(resp => resp.data).catch(error => error);
	},
	getCities(data) {
		return instance().post(`/cities`, data).then(resp => resp.data).catch(error => error);
	},
	getStates(data) {
		return instance().post(`/states`, data).then(resp => resp.data).catch(error => error);
	}
};
